import { Venture } from '../types/venture';
export const ventures: Venture[] = [{
  id: 'sekhi-capital',
  name: 'Sekhi Capital',
  mark: 'serif',
  category: 'Investment advisory',
  thesis: 'A SEBI-registered advisory practice handling financial planning, investment management, estate and tax planning for families and founders.',
  role: 'Principal — Investment Advisor',
  years: '2021 — now',
  place: 'Chennai',
  status: 'Operating',
  href: 'https://www.sekhicapital.com'
}, {
  id: 'argus-ventures',
  name: 'Argus Ventures',
  mark: 'caps',
  category: 'Venture studio',
  thesis: 'A studio I founded and ran for eight years, setting strategy and building a pipeline of small companies across tools, design, food and fashion — nationwide.',
  role: 'Founder, Partner & Chief Strategist',
  years: '2016 — 2023',
  place: 'Greater Chennai',
  status: 'Closed',
  brands: ['TalentX', 'Shot8 Studios', 'Tailor Fit', 'Cocos', 'Charle Wines'],
  href: 'https://www.argusventures.org'
}, {
  id: 'sekhi-digital',
  name: 'Sekhi Digital',
  mark: 'stacked',
  category: 'Product & growth',
  thesis: 'An in-house startup of Argus Ventures building development products and services, staffed with IIT graduates across tech, analytics and marketing.',
  role: 'Board Member',
  years: '2020 — 2022',
  place: 'Greater Chennai',
  status: "closed"
}, {
  id: 'sekhi',
  name: 'Sekhi',
  mark: 'lowercase',
  category: 'Co-working',
  thesis: 'A co-working space for millennials, designed to feel like the warmth of home with a set-up that pushes you to work.',
  role: 'Founder',
  years: '2017 — 2020',
  place: 'Chennai',
  status: 'Closed',
  href: 'https://www.sekhi.com'
}, {
  id: 'desiwaffles',
  name: 'DesiWaffles',
  mark: 'mono',
  category: 'Food & beverage',
  thesis: 'A waffle store chain built and run across Chennai.',
  role: 'Founder',
  years: '2016 — 2018',
  place: 'Chennai',
  status: "exit"
}, {
  id: 'likeg',
  name: 'LikeG',
  mark: 'dotted',
  category: 'Health foods',
  thesis: 'Sales and distribution of quinoa, chia seeds and millets in and across Tamil Nadu, before the category existed here.',
  role: 'Founder',
  years: '2016',
  place: 'Chennai',
  status: "exit"
}, {
  id: 'nova-india',
  name: 'Nova India',
  mark: 'caps',
  category: 'Talent network',
  thesis: 'Brought Nova — a global talent network of 10,000+ members — to India, recruiting the country’s brightest young professionals and building the partnership base.',
  role: 'Co-founder',
  years: '2015 — 2016',
  place: 'Bangalore · Singapore · Stockholm',
  status: 'Past'
}, {
  id: 'rang',
  name: 'Rang',
  mark: 'lowercase',
  category: 'Community',
  thesis: 'Founded and chaired the Chalmers Indian Association in Gothenburg, then stayed on its advisory board looking after the welfare of the community.',
  role: 'Founder & Chairman',
  years: '2013 — 2016',
  place: 'Gothenburg',
  status: 'Past'
}, {
  id: 'eat-in-bcn',
  name: 'Eat-in BCN',
  mark: 'serif',
  category: 'E-commerce',
  thesis: 'The first one. An online catering store in Barcelona selling packaged weekly and monthly lunches at €3 a meal, delivered free.',
  role: 'CEO & Founder',
  years: '2011',
  place: 'Barcelona',
  status: "exit"
}];